import { Component, Input } from '@angular/core';
import { ScreenLoadingPresenter } from './screen-loading.presenter';
import { IScreenLoadingComponent, IScreenLoadingPresenter } from './interfaces';
import { IAbstractView } from '@core/interfaces';
import { CommonModule } from '@angular/common';
import { LoadingComponent } from '../loading/loading.component';

@Component({
	selector: 'app-screen-loading',
	standalone: true,
	imports: [CommonModule, LoadingComponent],
	templateUrl: './screen-loading.component.html',
	styleUrl: './screen-loading.component.scss',
	providers: [ScreenLoadingPresenter],
})
export class ScreenLoadingComponent extends IAbstractView<IScreenLoadingPresenter> implements IScreenLoadingComponent {
	combinedLoading$ = this.presenter.loading$;

	@Input() loading$ = this.presenter.loading$;
	@Input() loadingList$ = this.presenter.loadingList$;

	constructor(presenter: ScreenLoadingPresenter) {
		super(presenter);
	}
}
